import React, { Component } from 'react'
import { AppContext } from '@lightspeed-invoicing/core-client/frontend'
import {
    Router,
    Route,
} from 'react-router-dom'
import { createBrowserHistory } from 'history'
import PublicRoutes from '../publicroutes.jsx'
import { FormattedMessage } from 'react-intl'
import $ from 'jquery'
import GoogleTagManagerTracking from './GoogleTagManagerTracking.jsx'
import TagManager from 'react-gtm-module'
import EventBus from "./EventBus.js"

const history = createBrowserHistory()

history.listen((location, action) => {
    EventBus.dispatch(EventBus.TopicHistoryChanged, {
        didRefresh: true,
        location: location,
        action: action,
    })
})

class PublicApp extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            user: AppContext.getUserLoggedIn(),
            error: '',
        }
        this.closeError = this.closeError.bind(this)
        this.handleError = this.handleError.bind(this)
        this.trackHubSpotPageView = this.trackHubSpotPageView.bind(this)
        if (this.isAnalyticsEnabled()) {
            this.setupFullStory()
        }
        EventBus.listen(EventBus.TopicHistoryChanged, 'app-public-component', this.trackHubSpotPageView)
    }

    componentDidMount() {
    }

    isAnalyticsEnabled() {
        return AppContext.getCookie('analytics') !== 'disabled'
    }

    closeError() {
        this.setState({
            error: ''
        })
    }

    handleError(err) {
        let errorMessage = ''
        if (typeof err === "string") {
            errorMessage = err
        } else if (err.error) {
            errorMessage = err.error.message
        }
        if (errorMessage !== '' && err.error.code !== '500') {
            this.setState({
                error: <div className="main-alert alert alert-danger" role="alert" tabIndex="0">
                    <strong>
                        <FormattedMessage
                            id="main.error.title"
                            defaultMessage="Oops!"
                        />
                    </strong>
                    &nbsp;
                    {errorMessage}
                </div>
            }, () => {
                $('.main-alert').focus()
            })
            setTimeout(this.closeError, 5000)
        } else if (errorMessage !== '') {
            this.setState({
                error: <div className="main-alert alert alert-danger" role="alert" tabIndex="0">
                    <strong>
                        <FormattedMessage
                            id="main.error.title_internal"
                            defaultMessage="Internal Server Error!"
                        />
                    </strong>
                    <br />
                    <pre>{errorMessage}</pre>
                </div>
            }, () => {
                $('.main-alert').focus()
            })
            setTimeout(this.closeError, 60000)
        }
    }

    setupFullStory() {
        if (AppContext.getOptions().environment !== "prod") {
            return
        }
        if (window.location.pathname.startsWith("/p/proposals/") || window.location.pathname.startsWith("/p/signin") || window.location.pathname.startsWith("/p/signup")) {
            return
        }
        window['_fs_debug'] = false;
        window['_fs_host'] = 'fullstory.com';
        window['_fs_org'] = 'C7TKZ';
        window['_fs_namespace'] = 'FS';
        (function (m, n, e, t, l, o, g, y) {
            if (e in m) {
                if (m.console && m.console.log) {
                    m.console.log('FullStory namespace conflict. Please set window["_fs_namespace"].');
                }
                return;
            }
            g = m[e] = function (a, b) {
                g.q ? g.q.push([a, b]) : g._api(a, b);
            };
            g.q = [];
            o = n.createElement(t);
            o.async = 1;
            o.src = 'https://' + _fs_host + '/s/fs.js';
            y = n.getElementsByTagName(t)[0];
            y.parentNode.insertBefore(o, y);
            g.identify = function (i, v) {
                g(l, { uid: i });
                if (v) g(l, v)
            };
            g.setUserVars = function (v) {
                g(l, v)
            };
            g.shutdown = function () {
                g("rec", !1)
            };
            g.restart = function () {
                g("rec", !0)
            };
            g.consent = function (a) {
                g("consent", !arguments.length || a)
            };
            g.identifyAccount = function (i, v) {
                o = 'account';
                v = v || {};
                v.acctId = i;
                g(o, v)
            };
            g.clearUserCookie = function () {
            };
        })(window, document, window['_fs_namespace'], 'script', 'user');
    }

    trackHubSpotPageView(event, path) {
        if (AppContext.getOptions().environment !== "prod") {
            return
        }
        const _hsq = window._hsq = window._hsq || []
        _hsq.push(['setPath', path || event.getData().location.pathname])
        _hsq.push(['trackPageView']);
    }

    render() {

        let content = PublicRoutes.map((route, index) => {
            const containerClass = route.centered ? 'container' : ''
            return <div key={index} className={containerClass}>
                <Route
                    key={index}
                    path={route.path}
                    exact={route.exact}
                    component={this.isAnalyticsEnabled() ? GoogleTagManagerTracking(route.main) : route.main}
                />
            </div>
        })
        return (
            <Router history={history}>
                <div className="container-fluid px-0">
                    <div >
                        <div className="container">
                            {this.state.error}
                        </div>
                        {content}
                    </div>
                </div>
            </Router>
        );
    }
}

export default PublicApp


// WEBPACK FOOTER //
// ./src/common/publicapp.component.jsx